module.exports = __webpack_public_path__ + "static/media/arrow_down_black.d1b432c6.svg";